import WebApp from '@twa-dev/sdk';

import { atom } from 'jotai';

export const isLoadingAtom = atom(true);
export const isServerErrorAtom = atom(false);
export const platformAtom = atom(WebApp.platform);
export const clickerAtom = atom({
  id: '',
  balance: 0,
  rank: 0,
  firstName: '',
  lastName: '',
  username: '',
});
export const currentUserAtom = atom({
  id: WebApp.initDataUnsafe.user?.id ?? '0',
  username: WebApp.initDataUnsafe.user?.username ?? '0xKit2',
  firstName: WebApp.initDataUnsafe.user?.first_name ?? 'Ultron',
  lastName: WebApp.initDataUnsafe.user?.last_name ?? 'Studio',
  photoUrl: WebApp.initDataUnsafe.user?.photo_url ?? 'Unknown',
});

export const userAtom = atom((get) => ({
  currentUser: get(currentUserAtom),
  clicker: get(clickerAtom),
  isLoading: get(isLoadingAtom),
  isServerError: get(isServerErrorAtom),
  platform: get(platformAtom),
}));
